"use strict";

exports.__esModule = true;
exports["default"] = sharedKeys;

function sharedKeys(objA, objB) {

  if (!objA || !objB) {
    return [];
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length === 0 || keysB.length === 0) {
    return [];
  }

  if (objA === objB) {
    return keysA;
  }

  var sharedKeys = [];

  var hasOwn = Object.prototype.hasOwnProperty;
  for (var _iterator = keysA, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var keyA = _ref;

    if (hasOwn.call(objB, keyA)) {
      sharedKeys.push(keyA);
    }
  }

  return sharedKeys;
}

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/react-tunnel/lib/utils/sharedKeys.js
// module id = 1056
// module chunks = 4